import {
  GETRULEMAPPINGCHECK_SUCCESS,
  GETRULEMAPPINGCHECK_FAILED,
  RESET_GETRULEMAPPINGCHECK,
  LOADING_GETRULEMAPPINGCHECK,
  NETWORK_ERROR_GETRULEMAPPINGCHECK,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetRuleMappingCheck = () => {
  return { type: RESET_GETRULEMAPPINGCHECK };
};

const getRuleMappingCheck = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETRULEMAPPINGCHECK });
  await partnerServices
    .post("rulesMappingForMerchantList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getRuleMappingChecksuccess(res.data));
          break;
        default:
          dispatch(getRuleMappingCheckFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETRULEMAPPINGCHECK, payload: err });
    });
};
function getRuleMappingChecksuccess(data) {
  return {
    type: GETRULEMAPPINGCHECK_SUCCESS,
    payload: data,
  };
}
function getRuleMappingCheckFailed(data) {
  return {
    type: GETRULEMAPPINGCHECK_FAILED,
    payload: data,
  };
}

export { resetGetRuleMappingCheck, getRuleMappingCheck };
